<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="90px">
      <el-form-item label="DSP简称" prop="dspName">
        <el-input v-model="form.dspName"  placeholder="请输入DSP简称"/>
      </el-form-item>
      <el-form-item label="公司名称" prop="companyName">
        <el-input v-model="form.companyName"  placeholder="请输入公司名称"/>
      </el-form-item>
      <el-form-item label="联系人" prop="contactPerson">
        <el-input v-model="form.contactPerson"  placeholder="请输入联系人"/>
      </el-form-item>
      <el-form-item label="联系电话" prop="contactPhone">
        <el-input v-model="form.contactPhone"  placeholder="请输入联系电话"/>
      </el-form-item>
      <el-form-item label="联系邮箱" prop="contactEmail">
        <el-input v-model="form.contactEmail"  placeholder="请输入联系邮箱"/>
      </el-form-item>
      <el-form-item label="请求地址" prop="bidUrl">
        <el-input v-model="form.bidUrl"  placeholder="请输入请求地址"/>
      </el-form-item>
      <el-form-item label="包含预算" prop="budget">
        <el-checkbox-group v-model="form.budget">
          <el-checkbox v-for="item in budgetList" :label="item.budgetId" :key="item.budgetId">{{
              item.budgetName
            }}
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="替换域名" prop="replaceDomainStatus">
        <el-radio v-model="form.replaceDomainStatus" :label="0">不替换</el-radio>
        <el-radio v-model="form.replaceDomainStatus" :label="1">替换</el-radio>
        <el-input v-if="form.replaceDomainStatus === 1" v-model="form.primaryDomainName" placeholder="请输入预算主域名"/>
      </el-form-item>
      <el-form-item label="预算排序">
        <el-input type="number" v-model="form.sort" placeholder="1最大"/>
      </el-form-item>
      <el-form-item label="DSP类型" prop="dspType">
        <el-select
          v-model="form.dspType"

          placeholder="DSP类型"
        >
          <el-option label="CPM" :value="1"/>
          <el-option label="CPA" :value="2"/>
          <el-option label="通用" :value="3"/>
        </el-select>
      </el-form-item>
      <el-form-item label="QPS阈值" prop="dspThreshold">
        <el-input type="number" v-model="form.dspThreshold" placeholder="请输入QPS阈值"/>
      </el-form-item>
      <el-form-item label="价格密钥" prop="ekey">
        <el-input v-model="form.ekey"  placeholder="请输入价格密钥"/>
      </el-form-item>
      <el-form-item label="价格宏" prop="priceMacro">
        <el-input v-model="form.priceMacro"  placeholder="请输入价格宏"/>
      </el-form-item>
    </el-form>
    <div style="text-align: right;">
      <el-button @click="close" >取消</el-button>
      <el-button @click="submit" type="primary"  :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addDsp, updateDsp } from '@/api/manage/dsp/dsp'
import { getSlotBudget } from '@/api/select'

const form = {
  dspName: undefined,
  companyName: undefined,
  contactPerson: undefined,
  contactPhone: undefined,
  contactEmail: undefined,
  bidUrl: undefined,
  replaceDomainStatus: 0,
  primaryDomainName: undefined,
  budget: [],
  dspType: 1,
  dspThreshold: undefined,
  ekey: undefined,
  priceMacro: undefined
}
export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 600
    },
    data: Object
  },
  emits: ['submit'],
  data () {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, form),
      rules: {
        dspName: [{ required: true, message: '请输入DSP简称', trigger: 'blur' }],
        companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
        contactPerson: [{ required: false, message: '请输入联系人', trigger: 'blur' }],
        contactPhone: [{ required: false, message: '请输入联系电话', trigger: 'blur', pattern: /^1[0-9]{10}$/ }],
        contactEmail: [{
          required: false,
          message: '请输入联系邮箱',
          trigger: 'blur',
          pattern: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/
        }],
        bidUrl: [{ required: true, message: '请输入请求地址', trigger: 'blur' }],
        dspType: [{ required: true, message: '请选择DSP类型', trigger: 'blur' }],
        budget: [{ required: true, message: '请选择包含预算', trigger: 'blur' }],
        dspThreshold: [{ required: false, message: '请输入QPS阈值', trigger: 'blur', pattern: /^[0-9]*$/ }],
        ekey: [{ required: false, message: '请输入价格密钥', trigger: 'blur' }],
        priceMacro: [{ required: false, message: '请输入价格宏', trigger: 'blur' }]
      },
      budgetList: []
    }
  },
  computed: {
    dialogTitle () {
      return (this.title ? this.title : '') + (this.form.dspId ? '编辑' : '新增')
    }
  },
  created () {
    this.getSlotBudget()
  },
  methods: {
    getSlotBudget () {
      getSlotBudget().then(res => {
        if (res.code === 200) {
          this.budgetList = res.data
        }
      })
    },
    show (data) {
      this.dialogStatus = true
      if (data) {
        this.form = Object.assign({}, data)
        if (!data.budgetNameIdList) {
          data.budgetNameIdList = []
        }
        this.form.budget = data.budgetNameIdList.map((item) => {
          return item.budgetId
        })
      }
    },
    close () {
      this.dialogStatus = false
      this.reset()
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.dspId) {
            this.updateDsp(this.form)
          } else {
            this.addDsp(this.form)
          }
        }
      })
    },
    addDsp (form) {
      this.submitLoading = true
      this.form.budget = this.form.budget.join(',')
      addDsp(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    updateDsp (form) {
      this.submitLoading = true
      this.form.budget = this.form.budget.join(',')
      updateDsp(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    reset () {
      this.form = Object.assign({}, form)
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
</style>
